module.exports = __webpack_public_path__ + "img/advanteges-bg.0b48f879.png";